import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export interface IToastContentProps {
  remainingTime: string;
  advice: string;
}
interface IRemainingToastLayoutProps {
  data: IToastContentProps;
}

export const RemainingToastLayout: FC<IRemainingToastLayoutProps> = ({
  data,
}) => {
  const { t } = useTranslation();
  return (
    <div className="flex justify-between items-center gap-2 flex-col min-[480px]:flex-row">
      <p className="text-sm flex items-center">
        <b className="font-bold block grow-0 w-[42px] overflow-visible whitespace-nowrap">
          {data.remainingTime.slice(1)}
        </b>
        <span className="min-[480px]:block hidden ">
          &nbsp;
          {t('avatar.remaining', { advice: data.advice })}
        </span>
      </p>
      <Link to="/pricing" className="btn btn-secondary btn-small ">
        {t('credits.buyCredits')}
      </Link>
    </div>
  );
};
